(ns common.schema.entities.exit-opportunity-stage
  (:require
   [common.schema.schema-utils :as su]))

;; The stage-picking option filter belongs on the ref fields that offer
;; stages (:oppo/stage and the opportunity/sales/exit equivalents), which all
;; carry it. It was set on this name field too, where
;; su/name-unique-with-another-attribute-field dropped it silently - a
;; qualified key against an unqualified destructure - and where a text editor
;; has no options to filter anyway. Removed rather than activated.
(def schema
  (concat (su/name-unique-with-another-attribute-field :exit-opportunity-stage/name
                                                       "Name" :entity.type/exit-opportunity-stage
                                                       :exit-opportunity-stage/pipeline
                                                       {:system-required? true
                                                        :system-semantics
                                                        su/user-provided-system-required-field-semantics})
          (su/single-ref-field :exit-opportunity-stage/pipeline
                               "Pipeline"
                               [:entity.type/pipeline]
                               {:mandatory-config         :mandatory/always
                                :default-field-visibility :in-use-disabled
                                :system-required?         true
                                :system-semantics
                                su/user-provided-system-required-field-semantics})))
